export interface VacancyProfessionModel {
  id: string;
  alias_id: string | null;
  name: string | null;
}

export interface VacancyProfessionsInfoModel {
  vacancy_id: string | null;
  official_job_title: string | null;
  professions: VacancyProfessionModel[] | null;
  company_name: string | null;
  role_description: string | null;
}
